import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">Distribution House</DialogTitle>
      <DialogContent>
        <DialogContentText>
          X:Y where, <br />
          X = Number of DH with current stock above it's stock target and
          <br />
          Y = Number of DH with current stock below it’s stock target
          <br />
          DH stock target is set separately for each DH for the current month
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
